export const machineLearningCourses = [
    {
      title: "Machine Learning Course 1",
      description: "This is the description for Machine Learning Course 1",
      rating: 4.5,
      price: "$199",
      imageUrl: "https://example.com/image1.jpg",
    },
    {
      title: "Machine Learning Course 2",
      description: "This is the description for Machine Learning Course 2",
      rating: 4.2,
      price: "$149",
      imageUrl: "https://example.com/image2.jpg",
    },
    {
      title: "Machine Learning Course 3",
      description: "This is the description for Machine Learning Course 3",
      rating: 4.2,
      price: "$149",
      imageUrl: "https://example.com/image2.jpg",
    },
    // Add more machine learning courses as needed
  ];
  
  export const dataScienceCourses = [
    {
      title: "Data Science Course 1",
      description: "This is the description for Data Science Course 1",
      rating: 4.8,
      price: "$249",
      imageUrl: "https://example.com/image3.jpg",
    },
    {
      title: "Data Science Course 2",
      description: "This is the description for Data Science Course 2",
      rating: 4.7,
      price: "$199",
      imageUrl: "https://example.com/image4.jpg",
    },
    {
      title: "Data Science Course 3",
      description: "This is the description for Data Science Course 3",
      rating: 4.7,
      price: "$199",
      imageUrl: "https://example.com/image4.jpg",
    },
    // Add more data science courses as needed
  ];

  export const courseContent = [
    {
      module: "Module 1",
      lectures: ["Lecture 1", "Lecture 2", "Lecture 3"],
      pdf: <i class="bi bi-file-pdf text-4xl"></i>,
      video:<i class="bi bi-play text-4xl"></i>
    },
    {
      module: "Module 2",
      lectures: ["Lecture 1", "Lecture 2", "Lecture 3"],
      pdf: <i class="bi bi-file-pdf text-4xl"></i>,
      video:<i class="bi bi-play text-4xl"></i>
    },
    {
      module: "Module 3",
      lectures: ["Lecture 1", "Lecture 2", "Lecture 3"],
      pdf: <i class="bi bi-file-pdf text-4xl"></i>,
      video:<i class="bi bi-play text-4xl"></i>
    },
    {
        module: "Module 4",
        lectures: ["Lecture 1", "Lecture 2", "Lecture 3"],
        pdf: <i class="bi bi-file-pdf text-4xl"></i>,
        video:<i class="bi bi-play text-4xl"></i>
      }
    // Add more modules as needed
  ];
  